"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = void 0;
var _react = _interopRequireDefault(require("react"));
var _getDataProps = _interopRequireDefault(require("../../utils/getDataProps"));
var _CssClassNames2 = _interopRequireDefault(require("../../scss/CssClassNames"));
var _excluded = ["children", "tag", "addBreaklines", "style"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var _CssClassNames = new _CssClassNames2["default"]({}, ['text', 'utility']),
  className = _CssClassNames.className,
  getCssProp = _CssClassNames.getCssProp;
var Text = function Text(_ref) {
  var children = _ref.children,
    tag = _ref.tag,
    _ref$addBreaklines = _ref.addBreaklines,
    addBreaklines = _ref$addBreaklines === void 0 ? true : _ref$addBreaklines,
    style = _ref.style,
    props = _objectWithoutProperties(_ref, _excluded);
  var Tag = ['p', 'span', 'div', 'li', 'blockquote'].includes(tag) ? tag : 'span';
  return /*#__PURE__*/_react["default"].createElement(Tag, _extends({}, (0, _getDataProps["default"])(props), className("\n                ".concat(props.className || '', "\n                ").concat(getCssProp(props, ['mt', 'mb']), "\n            ")), {
    style: style ? style : null,
    dangerouslySetInnerHTML: {
      __html: children ? addBreaklines ? children.replace(/(?:\r\n|\r|\n)/g, '<br>') : children : ''
    }
  }));
};
exports.Text = Text;